import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { getTransportUsersList } from '../../requests/get_transport_users_list_request';
import { getTransportUsersListSuccess, getTransportUsersListFailure } from '../actions/get_transport_users_list.actions';
import { GET_TRANSPORT_USERS_LIST } from '../constants/get_transport_users_list.constants';

function* getTransportUsersListRequest({ searchText }) {
    const transport_users = yield call(getTransportUsersList, searchText);

    if (transport_users.result) {
        yield put(getTransportUsersListSuccess(transport_users.options));
    } else {
        yield put(getTransportUsersListFailure(transport_users.error));
        message.error(transport_users.error.message || transport_users.error.msg || 'Error occured upon request, contact admin please');
    }
}

export default function* getTransportUsersListSaga() {
    yield takeEvery(GET_TRANSPORT_USERS_LIST, getTransportUsersListRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_transport_users_list.saga.js